// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bottom-space {
  margin-bottom: 20px;
}
.partner-delete-icon {
  display: flex;
  justify-content: end;
  align-items: center;
}
.beneficiaryAllocationBar {
  height: 103px;
  padding: 20px;
  align-items: center;
  background-color: #fbf2e0;
  margin-bottom: 20px;
}
.beneficiaryAllocationBar {
  position: sticky;
  position: -webkit-sticky;
  top: 138px;
  z-index: 10;
  padding-top: 0;
  height: 82px;
}
.beneficiaryAllocationBar:after {
  position: absolute;
  width: calc(100% + 40px);
  height: calc(100% + 20px);
  left: -20px;
  top: -20px;
  background: #fbf2e0;
  content: "";
}
.beneficiaryAllocationBar .allocation__heading {
  margin-bottom: 5px;
}
.beneficiaryAllocationBar__subcontainer {
  z-index: 1;
  width: 100%;
}
.beneficiaryAllocationBar__contents {
  width: 50%;
}
.beneficiaryAllocationBar__contents:first-child {
  padding-right: 60px;
  position: relative;
}
.beneficiaryAllocationBar__contents:first-child::after {
  content: "";
  position: absolute;
  height: 55px;
  width: 5px;
  border-radius: 10px;
  background: #000;
  right: 0;
  top: 4px;
}
.beneficiaryAllocationBar__contents:last-child {
  padding-right: 30px;
  padding-left: 40px;
}
.beneficiaryAllocationBar .allocationText {
  display: flex;
  align-items: center;
}
.beneficiaryAllocationBar__subcontainer .beneficiaryAllocation__error {
  font-size: 14px;
  color: #f00;
  position: relative;
  padding-left: 25px;
}
.beneficiaryAllocationBar__subcontainer .beneficiaryAllocation__error:before {
  content: "";
  position: absolute;
  height: 19px;
  width: 19px;
  border: 2px solid #ff0000;
  border-radius: 50%;
  left: 2px;
  top: -1px;
}
.beneficiaryAllocationBar__subcontainer .beneficiaryAllocation__error:after {
  content: "!";
  position: absolute;
  left: 10px;
  top: 2px;
  font-size: 13px;
  color: #ff0000;
}
.beneficiaryAllocationBar .allocatedLabel {
  font-size: 16px;
  font-weight: 600;
  font-size: 14px;
  color: #12b117;
}
.beneficiaryAllocationBar .percentage__container {
  min-width: 0;
  padding-right: 10px;
}
.beneficiaryAllocationBar .percentage__container p {
  font-weight: 600;
}
.percentage__container {
  font-size: 30px;
  padding-right: 16px;
  min-width: 60px;
  flex-direction: column;
}
#progressbar {
  background-color: white;
  border-radius: 13px;
  margin-top: 4px;
  border: 1px;
}
#progressbar > div {
  background-color: #12b117;
  height: 6px;
  border-radius: 13px;
}
.beneficiary-question {
  font-size: 14px;
  padding: 14px 0px;
}
.beneficiary-text-field > .label-value-wrapper {
  margin-right: 0px;
  margin-bottom: 0px;
}
.trust-per {
  margin-top: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/beneficiary/beneficiary.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,UAAU;EACV,WAAW;EACX,cAAc;EACd,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,QAAQ;EACR,QAAQ;AACV;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,SAAS;AACX;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB","sourcesContent":[".bottom-space {\n  margin-bottom: 20px;\n}\n.partner-delete-icon {\n  display: flex;\n  justify-content: end;\n  align-items: center;\n}\n.beneficiaryAllocationBar {\n  height: 103px;\n  padding: 20px;\n  align-items: center;\n  background-color: #fbf2e0;\n  margin-bottom: 20px;\n}\n.beneficiaryAllocationBar {\n  position: sticky;\n  position: -webkit-sticky;\n  top: 138px;\n  z-index: 10;\n  padding-top: 0;\n  height: 82px;\n}\n.beneficiaryAllocationBar:after {\n  position: absolute;\n  width: calc(100% + 40px);\n  height: calc(100% + 20px);\n  left: -20px;\n  top: -20px;\n  background: #fbf2e0;\n  content: \"\";\n}\n.beneficiaryAllocationBar .allocation__heading {\n  margin-bottom: 5px;\n}\n.beneficiaryAllocationBar__subcontainer {\n  z-index: 1;\n  width: 100%;\n}\n.beneficiaryAllocationBar__contents {\n  width: 50%;\n}\n.beneficiaryAllocationBar__contents:first-child {\n  padding-right: 60px;\n  position: relative;\n}\n.beneficiaryAllocationBar__contents:first-child::after {\n  content: \"\";\n  position: absolute;\n  height: 55px;\n  width: 5px;\n  border-radius: 10px;\n  background: #000;\n  right: 0;\n  top: 4px;\n}\n.beneficiaryAllocationBar__contents:last-child {\n  padding-right: 30px;\n  padding-left: 40px;\n}\n.beneficiaryAllocationBar .allocationText {\n  display: flex;\n  align-items: center;\n}\n.beneficiaryAllocationBar__subcontainer .beneficiaryAllocation__error {\n  font-size: 14px;\n  color: #f00;\n  position: relative;\n  padding-left: 25px;\n}\n.beneficiaryAllocationBar__subcontainer .beneficiaryAllocation__error:before {\n  content: \"\";\n  position: absolute;\n  height: 19px;\n  width: 19px;\n  border: 2px solid #ff0000;\n  border-radius: 50%;\n  left: 2px;\n  top: -1px;\n}\n.beneficiaryAllocationBar__subcontainer .beneficiaryAllocation__error:after {\n  content: \"!\";\n  position: absolute;\n  left: 10px;\n  top: 2px;\n  font-size: 13px;\n  color: #ff0000;\n}\n.beneficiaryAllocationBar .allocatedLabel {\n  font-size: 16px;\n  font-weight: 600;\n  font-size: 14px;\n  color: #12b117;\n}\n.beneficiaryAllocationBar .percentage__container {\n  min-width: 0;\n  padding-right: 10px;\n}\n.beneficiaryAllocationBar .percentage__container p {\n  font-weight: 600;\n}\n.percentage__container {\n  font-size: 30px;\n  padding-right: 16px;\n  min-width: 60px;\n  flex-direction: column;\n}\n#progressbar {\n  background-color: white;\n  border-radius: 13px;\n  margin-top: 4px;\n  border: 1px;\n}\n#progressbar > div {\n  background-color: #12b117;\n  height: 6px;\n  border-radius: 13px;\n}\n.beneficiary-question {\n  font-size: 14px;\n  padding: 14px 0px;\n}\n.beneficiary-text-field > .label-value-wrapper {\n  margin-right: 0px;\n  margin-bottom: 0px;\n}\n.trust-per {\n  margin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
